import {omit} from 'lodash';
import {getUser} from 'shared/actions/student';
import {errorMessage} from 'shared/actions/notifications';
import {stopLoading} from 'shared/actions/loading';
import {receiveNotificationSettings} from 'shared/account-settings/actions/notification-settings';

export const RECEIVE_STUDENT = 'RECEIVE_STUDENT';

export const receiveStudent = (student) => ({
  type: RECEIVE_STUDENT,
  student,
});

export const STUDENT_FIELDS = [
  '_id',
  'firstName',
  'lastName',
  'email',
  'addressLine1',
  'addressLine2',
  'postalCode',
  'city',
  'subdivision',
  'country',
  'addressVerified',
  'confirmedUnverifiedAddress',
  'birthdayDay',
  'birthdayMonth',
  'birthdayYear',
  'gender',
  'customGenderIdentity',
  'sex',
  'religion',
  'customReligion',
  'usCitizenOrResident',
  'isUsCitizenOrResident',
  'countryOfCitizenship',
  'ethnicity',
  'highSchoolInfo',
  'communityCollegeInfo',
  'currentInstitution',
  'isFirstGen',
  'fafsaSubmission',
  'mobile',
  'mobileVerified',
  'autoConnectCounselors',
  'shareDataWithAllSchools',
  'educationPhase',
  'parentEmail',
].join(',');

export const getStudentInfo = () => (dispatch) =>
  getUser('me', `${STUDENT_FIELDS},notificationSettings`)
    .then((student) => {
      dispatch(receiveStudent(omit(student, ['notificationSettings'])));
      dispatch(receiveNotificationSettings(student.notificationSettings));

      dispatch(stopLoading());
    })
    .catch(() => {
      dispatch(errorMessage());
    });
